import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart from "./Cart";
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import {generateCartItemsFrom} from './Cart';

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */


const Products = () => {
  const { enqueueSnackbar } = useSnackbar();
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const [products, setProducts] = useState([]);
  const [loading, setloading] = useState(false);
  const token = localStorage.getItem('token');
  const [IdCart, setIdCart] = useState([]);
  const[debounceTimeout, setDebounceTimeout]= useState(500);

  useEffect(() => {

    performAPICall();
    fetchCart(token);
    /*
      const productData = await performAPICall();
      if (token) {
        const cartData = await fetchCart(token);
        
        console.log("cartData", cartData);
        console.log("idcart", IdCart);
        console.log("productsdata", productData);
        const cartDetails =  generateCartItemsFrom(cartData, productData);
        console.log("carddetails", cartDetails);
        setItemsInCart(cartDetails);
        console.log("itemsInCart", itemsInCart);
      }
    };
    onLoadHandler();*/
  },[]);
 


  const performAPICall = async () => {
    let URL = config.endpoint+`/products`;
        try{
            setloading(true);
            const res = await axios.get(URL);
            setProducts(res.data);
            console.log(res.data);
            //console.log("products inside api call", products);
            setloading(false);
            return res.data;
        }
        catch(error){
          enqueueSnackbar(error.response.data.message, { variant: "error" });
          console.log(error);
          setloading(false);
        }
        
  };
 
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
   
   //const[isFound, setFound]= useState(false);
   

    const performSearch = async (text) => {
    let URL = config.endpoint+`/products`;

    if (text && text.length > 0) {
      console.log("value", text);
      URL = `${URL}/search?value=${text}`;
    }
    try{
      setloading(true);
      const res = await axios.get(URL);
      setProducts(res.data);
      console.log(res.data);
      
      }
      catch(error){
        if(error.response.status===404){
          setProducts([]);
        }
        enqueueSnackbar(error.response.data.message, { variant: "error" });
        console.log(error.response);
      }

  setloading(false);
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
   
  const debounceSearch = (event, debounceTimeout) => {
    
   if (debounceTimeout !== 0) {
      clearTimeout(debounceTimeout);
    }

    let debTimout = setTimeout(() => {
      performSearch(event);//async operation , can have old val
    }, 500);

    console.log(debTimout);
    setDebounceTimeout(debTimout);
    // debounce login to stop making api request

  };


  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
  
  const fetchCart = async (token) => {
    if (!token) return;
    let URL = config.endpoint+`/cart`;
    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
        const response = await axios.get(URL, { headers: {"Authorization" : `Bearer ${token}`} });
        console.log(response.data);
        setIdCart(response.data);
        //console.log("idcart--",IdCart);
        //console.log("inside api call", IdCart);
        //return response.data;

    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };
 

  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
  

  const isItemInCart = (items, productId) => {
    for(let i=0; i<items.length; i++){
      if(items[i]["productId"]===productId){
        return true;
      }
    }
    return false;
  };

  /*const updateCartItems = async(addedItem, products) => {
    const cartDataDetails = await generateCartItemsFrom(addedItem, products);
    setItemsInCart(cartDataDetails);
  };*/
  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {

    if (!token) {
      enqueueSnackbar("Login to add an item to the Cart", {
        variant: "warning",
      });
      return;
    }
   
    if(options.preventDuplicate && isItemInCart(items, productId)){
      enqueueSnackbar(
        "Item already in cart. Use the cart sidebar to update quantity or remove item.",
        {
          variant: "warning",
        }
      );
      return;
    }
    let postDataFromPageToCart = {
      productId: productId,
      qty: qty,
    };
    
      let URL = config.endpoint+`/cart`;
      try{
        const response = await axios.post(URL, postDataFromPageToCart, { headers: {"Authorization" : `Bearer ${token}`} });
        console.log(response);
        const data = response.data;
        setIdCart(data);
        //const updatedCart = await updateCartItems(data, products);
        //setItemsInCart(updatedCart);
        //console.log("idcart", IdCart);
      }
      catch(error){
        console.log(error.response);
        enqueueSnackbar(
          error.response,
          {
            variant: "error",
          }
        );
      }
  };

  return (
    <div>
      <Header hasHiddenAuthButtons={true} sx={{mb:1}}>
        {/*search for desktop*/}
      <TextField
        className="search-desktop"
        size="small"
        InputProps={{
          className: 'search',
          endAdornment: (
            <InputAdornment position="end" >
              <Search color="primary" />
            </InputAdornment>
          ), 
        } }
        placeholder="Search for items/categories"
        name="search"
        //value={text}
        onChange = {(e)=>debounceSearch(e.target.value,debounceTimeout)}
      />
      </Header>
        {/*search for mobile*/}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        //value = {text}
        onChange = {(e)=>debounceSearch(e.target.value,debounceTimeout)}
      />
      
       <Grid container rowSpacing={1} style={{paddingTop:8}}>
         <Grid item className="product-grid" md={token ? 9 : 12} xs={12} style = {{paddingTop:0}}>
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box >
           { !loading && (products.length>0) &&<Box className = "card-text">
           <Grid  container spacing={2} >
                {products.map((ele) => {
              return (
                <Grid item xs={6} sm={4} md={3} key={ele._id}>
                  <ProductCard product={ele} handleAddToCart={async () => {
                    await addToCart ( token,
                    IdCart,
                    products,
                    ele._id,
                    1,
                    { preventDuplicate: true }
                  )
                  }}/>
                </Grid>
              );
            })}
            </Grid>
            </Box>
          }
          {(products.length===0) && !loading && <Box className = "not-found">
            <div>
            <SentimentDissatisfiedIcon/>
            </div>
            <div>
            No products found
            </div>
            
          </Box>
          }
          {/*!loading && error && <div>{isError}</div>*/}
          {loading && <div className="display-loading">
            <div >
            <CircularProgress color="success"/>
            </div>
            <div>
            Loading Products...
            </div>
            </div>}
         </Grid>
         {(localStorage.getItem('token')!==null) && ( <Grid item xs={12} md={3} className = "cart-grid" style = {{paddingTop:0}}>
         <Cart products={products} items = {generateCartItemsFrom(IdCart, products)} handleQuantity={addToCart}/> 
         </Grid>)}

       </Grid>

        {/* TODO: CRIO_TASK_MODULE_CART - Display the Cart component */}
        
       
      <Footer />
    </div>
  );
};

export default Products;
